import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState } from "react";
export function useDragScroll(targetRef) {
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      startDrag = _useState2[0],
      setStartDrag = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      endDrag = _useState4[0],
      setEndDrag = _useState4[1];

  useEffect(function () {
    if (targetRef.current == null) return;
    var slider = targetRef.current;
    var isDown = false;
    var startX;
    var scrollLeft;

    function startDragging(e) {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      setStartDrag(scrollLeft);
    }

    function endDrag() {
      isDown = false;
      setEndDrag(slider.scrollLeft);
    }

    function dragMove(e) {
      if (!isDown) return;
      var x = e.pageX - slider.offsetLeft;
      var step = (x - startX) * speed;
      slider.scrollLeft = scrollLeft - step;
    }

    slider.addEventListener("mousedown", startDragging);
    slider.addEventListener("mouseleave", endDrag);
    slider.addEventListener("mouseup", endDrag);
    slider.addEventListener("mousemove", dragMove);
    return function () {
      slider.removeEventListener("mousedown", startDragging);
      slider.removeEventListener("mouseleave", endDrag);
      slider.removeEventListener("mouseup", endDrag);
      slider.removeEventListener("mousemove", dragMove);
    };
  }, [targetRef, speed]);
  return [startDrag, endDrag];
}